import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";

const clientId = window.location.hostname === 'psicheckblotter.principal.com' ? 'c99f262e-9497-411d-90c1-7793c46b87f7' : '21a53bdf-e89f-44f2-80e3-47b29cdc78be';
const tenantId = window.location.hostname === 'psicheckblotter.principal.com' ? '3bea478c-1684-4a8c-8e85-045ec54ba430' : '50abac53-da5d-44dc-8586-587ec2d3d097';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider {...{
      onSigninCallback: (_user) => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        )
      },
      authority: `https://login.microsoftonline.com/${tenantId}/v2.0`,
      client_id: clientId,
      scope: 'api://psi-check-blotter/read api://psi-check-blotter/write',
      response_type: 'code',
      redirect_uri: window.location.origin,
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: true
    }}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
